import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";

function NotificationsTab({
    selectedUser,
    selectedUserData,
    setSelectedUserData,
}) {
    const [activeDevices, setActiveDevices] = useState([]);
    const [isLoading, setIsLoading] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [viewingNotificationsFor, setViewingNotificationsFor] = useState(null);

    useEffect(()=> {
        getUserActiveDevices();
    },[]);

    const getUserActiveDevices = async() => {
        setIsLoading(true);
        try {
            const response = await commonRunQuery(303, selectedUser); 
            if (response?.data?.header?.callStatus == "1" && response?.data?.header?.reccount !== "0") {
                const devicesArr = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
                setActiveDevices(devicesArr);
                console.log("activeDevices============",devicesArr);
            } else {
                setActiveDevices([]);
            }
        } catch (error) {
            console.log("getUserActiveDevices_error----------",error);
        } finally {
            setIsLoading(false);
        }
    }

    const handleViewNotifications = async (device) => {
        try {
            const response = await commonRunQuery(304, device.id);
            let notificationsData = [];
            if (response?.data?.header?.callStatus === "1") {
                if(response?.data?.header?.reccount !== "0") {
                    notificationsData = Array.isArray(response?.data?.body?.record) ? response.data.body.record : [response.data.body.record];
                } else {
                    notificationsData = [];
                }
                setViewingNotificationsFor(device); // store the device info
                setNotifications(notificationsData);
        
                console.log("Notifications for Device==============", notifications);
            } else {
                console.warn("No notifications found.");
            }
        } catch (error) {
          console.error("Error fetching notifications:", error);
        }
    };

    const handleBackToDevices = () => {
        setViewingNotificationsFor(null);
        setNotifications([]);
    };

    const parseNotificationMessage = (rawMessage) => {
        try {
            // First, try to parse as JSON
            let parsed;
        
            // Handle HTML entities first
            const decodedMessage = rawMessage
                .replace(/&quot;/g, '"')
                .replace(/&amp;/g, "&")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&#39;/g, "'")
                .replace(/&nbsp;/g, " ")
        
            try {
                parsed = JSON.parse(decodedMessage)
            } catch {
                // If JSON parsing fails, treat as plain text
                return {
                    title: "Notification",
                    body: rawMessage,
                }
            }
        
            // Helper function to decode unicode sequences and clean text
            const cleanText = (text) => {
                if (!text) return ""
        
                try {
                    // Handle unicode escape sequences
                    let cleaned = text.replace(/\\u[\dA-F]{4}/gi, (match) => {
                        try {
                            return String.fromCharCode(Number.parseInt(match.replace(/\\u/g, ""), 16))
                        } catch {
                            return match
                        }
                    })
        
                    // Handle malformed unicode sequences like \u00ef\u00bf\u00bd
                    cleaned = cleaned.replace(/\u00ef\u00bf\u00bd/g, "é") // Common replacement for corrupted é
            
                    // Remove any remaining control characters
                    cleaned = cleaned.replace(/[\x00-\x1F\x7F-\x9F]/g, "")
            
                    return cleaned.trim()
                } catch {
                    return text
                }
            }
    
            // Extract title and body with fallbacks
            const title = cleanText(parsed.title || "Notification")
            const body = cleanText(parsed.body || parsed.text || parsed.message || "No message content")
    
            return { title, body }
        } catch (error) {
            console.warn("Failed to parse notification message:", error)
            return {
                title: "Notification",
                body: rawMessage || "No message content",
            }
        }
    }

    return (
        <>
            {isLoading ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        overflow: "hidden",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : viewingNotificationsFor ? (
                <Box sx={{ p: 2 }}>
                    <Box sx={{ display:"flex", justifyContent:"space-between"  }}>
                        <Typography variant="h6" gutterBottom>
                            Notifications for Device: {viewingNotificationsFor.deviceid}
                        </Typography>
                        <button
                            onClick={handleBackToDevices}
                            style={{
                                marginBottom: "10px",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                backgroundColor: "#555",
                                color: "#fff",
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            Back to Devices
                        </button>
                    </Box>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Notification Time</TableCell>
                                    <TableCell>Title</TableCell>
                                    <TableCell>Body</TableCell>
                                    <TableCell>Language</TableCell>
                                    <TableCell>Sent</TableCell>
                                    <TableCell>Response</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {notifications?.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            No notifications found for this device.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    notifications?.map((nObj, i) => {
                                        const noti = nObj?.userpushnotificationhistory;
                                        const { title, body } = parseNotificationMessage(noti.message);
                                        return (
                                            <TableRow key={noti.id || i}>
                                                <TableCell>{noti.id}</TableCell>
                                                <TableCell>{noti.notificationtime}</TableCell>
                                                <TableCell>{title}</TableCell>
                                                <TableCell>{body}</TableCell>
                                                <TableCell>{noti.language}</TableCell>
                                                <TableCell>{noti.issent === "1" ? "Yes" : "No"}</TableCell>
                                                <TableCell>{noti.response}</TableCell>
                                            </TableRow>
                                        );
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            ) : (
                <Box sx={{ overflow: "auto", p: 2 }}>
                    <Typography variant="h6" gutterBottom>
                        Active User Devices
                    </Typography>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Device Name</TableCell>
                                    <TableCell>Device Type</TableCell>
                                    <TableCell>Enrolled Time</TableCell>
                                    <TableCell>Last Login</TableCell>
                                    <TableCell>Active</TableCell>
                                    <TableCell>Allow Messages</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {activeDevices?.length > 0 && activeDevices?.map((deviceObj, index) => {
                                    const device = deviceObj?.userdevices;
                                    return (
                                        <TableRow key={device.id || index}>
                                            <TableCell>{device.id}</TableCell>
                                            <TableCell>{device.deviceid || "-"}</TableCell>
                                            <TableCell>{device.devicetype || "-"}</TableCell>
                                            <TableCell>{device.enrolledtime}</TableCell>
                                            <TableCell>{device.lastlogin}</TableCell>
                                            <TableCell>{device.active === "1" ? "Yes" : "No"}</TableCell>
                                            <TableCell>{device.allowmessages === "1" ? "Yes" : "No"}</TableCell>
                                            <TableCell>
                                                <button
                                                    onClick={() => handleViewNotifications(device)}
                                                    style={{
                                                        padding: "6px 12px",
                                                        borderRadius: "4px",
                                                        backgroundColor: "#1976d2",
                                                        color: "#fff",
                                                        border: "none",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    View Notifications
                                                </button>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            )}
        </>
    );
}

export default NotificationsTab;